import {Provider} from '@angular/core';

import {
  ListBanksUseCaseProvider
} from '@features/setting/presentation/providers/list-banks/list-banks.use-case.provider';

import {ListBanksFacade} from '@features/setting/presentation/facades/list-banks/list-banks.facade';
import {ListBanksHttpProvider} from '@features/setting/infrastructure/http/list-banks/list-banks.http.provider';

export const ListBanksFacadeProvider: Provider[] = [
    ...ListBanksHttpProvider,
  ListBanksUseCaseProvider,
  ListBanksFacade
];
